import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Version from "version";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import TextField from '@material-ui/core/TextField';
import pink from '@material-ui/core/colors/pink';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

const styles = theme => ({
    ...pricingPageStyle,
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    cssLabel: {
        '&$cssFocused': {
            color: pink[500],
        },
    },
    cssFocused: {},
    cssUnderline: {
        '&:after': {
            borderBottomColor: pink[500],
        },
    },
});

const theme = createMuiTheme({
    palette: {
        primary: pink,
    },
    typography: { useNextVariants: true },
});


class ChangeAddress extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ChangeAddress", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            CustomerType: '10',
            CompanyName: '',
            OrgNo: '',
            Firstname: '',
            Lastname: '',
            Birthdate: '',
            CoAddress: '',
            AddressLine: '',
            PostalCode: '',
            City: '',
            EmailAddress: '',
            ContactPhone: '',
            OrderSent: false,
            OrderError: '',
            buzy: false,
            ErrorField: '',
            ErrorText: '',
            EnterLastDigitsDialogOpen: false,
            lastDigits: '',
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.changeregistered'),
                html: this.props.t('selfcare:notification.addressupdatedwithinminutes'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.changefailed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            });
            this.setState({ buzy: false });
        }
        if (nextState.GeneralError && !this.state.GeneralError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.technicalerror'),
                html: nextState.GeneralError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            });
            this.setState({ buzy: false });
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            this.setState({ buzy: false });
            this.setFocus(nextState.ErrorField);
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }

    setFocus = fieldName => {
        switch (fieldName) {
            case "ContactPhone":
                if (this.ContactPhone) {
                    setTimeout(() => {
                        this.ContactPhone.focus();
                    }, 10);
                }
                break;
            case "EmailAddress":
                if (this.EmailAddress) {
                    setTimeout(() => {
                        this.EmailAddress.focus();
                    }, 10);
                }
                break;
            case "CoAddress":
                if (this.CoAddress) {
                    setTimeout(() => {
                        this.CoAddress.focus();
                    }, 10);
                }
                break;
            case "AddressLine":
                if (this.AddressLine) {
                    setTimeout(() => {
                        this.AddressLine.focus();
                    }, 10);
                }
                break;
            case "PostalCode":
                if (this.PostalCode) {
                    setTimeout(() => {
                        this.PostalCode.focus();
                    }, 10);
                }
                break;
            case "LastDigits":
                if (this.LastDigits) {
                    setTimeout(() => {
                        this.LastDigits.focus();
                    }, 10);
                }
                break;
        }
    }
    handleChange = name => event => {
        this.setState({ [name]: event.target.value, ErrorField: '' });
        if (name === 'PostalCode') {
            this.dispatchState({ Lookup: event.target.value });
        }
    }

    handleSave = () => {
        this.setState({ buzy: true, ErrorField: '' });
        this.dispatchState({ PerformChange: { Firstname: this.state.Firstname, Lastname: this.state.Lastname, CoAddress: this.state.CoAddress, AddressLine: this.state.AddressLine, PostalCode: this.state.PostalCode, EmailAddress: this.state.EmailAddress, ContactPhone: this.state.ContactPhone } });
    }
    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    render() {
        console.debug('ChangeAddress render');
        const classes = this.props;
        const { t } = this.props;
        const postcodelen = this.state.IsSweden ? 5 : 4;
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                <Dialog
                    open={this.state.EnterLastDigitsDialogOpen}
                    onClose={() => { this.setState({ EnterLastDigitsDialogOpen: false, buzy: false }); }}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        <div style={{ display: 'flex' }}>
                            <Icon name="edit" size={36} color="#e91e63" />
                            <span style={{ marginLeft: '20px', fontWeight: '700' }}>Sjekk med fødselsnummer</span>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        Ingen eller flere treff funnet i folkeregisteret<br /><br />
                        Du kan fullføre fødselsdatoen din med de fem siste sifrene og prøve igjen<br />
                        <GridContainer direction="row" alignItems="center" justify="center">
                            <GridItem style={{ fontSize: '1rem', textAlign: 'right' }} xs={6}>
                                {this.state.SsnStart} -&nbsp;
                            </GridItem>
                            <GridItem xs={6}>
                                <TextField error={this.state.ErrorField === 'LastDigits'} style={{ marginBottom: '16px' }}
                                    autoFocus
                                    disabled={this.state.buzy || this.state.Disabled}
                                    label="Siste 5 sifrene"
                                    value={this.state.lastDigits}
                                    onChange={this.handleChange('lastDigits')}
                                    id="LastDigits"
                                    type='tel'
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ maxLength: 5 }}
                                    className={classes.textField}
                                    helperText={this.state.ErrorField === 'LastDigits' && this.state.ErrorText}
                                    inputRef={(el) => { this.LastDigits = el; }}
                                />
                            </GridItem>
                        </GridContainer>
                        {this.state.AddressLookupErrorText && <div style={{ width: '100%', padding: '5px', color: '#e91e63', fontSize: '12px' }}>{this.state.AddressLookupErrorText}</div>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { this.setState({ AddressLookupErrorText: '' }); this.dispatchState({ SetLastDigits: this.state.lastDigits }); }} color="rose">
                            OK
                        </Button>
                        <Button onClick={() => { this.setState({ EnterLastDigitsDialogOpen: false, buzy: false, AddressLookupErrorText: '' }); }}>
                            AVBRYT
                        </Button>
                    </DialogActions>
                </Dialog>
                    <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }} className='white-links'>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                <Icon name="profile" size={48} color="#FFFFFF" />
                                <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:item.changeaddress')}
                                    </div>
                                {this.state.IsNorway && this.state.CustomerType === '10' && <div style={{ fontSize: '14px' }}>
                                    <span dangerouslySetInnerHTML={{ __html: t('selfcare:item.cannotchangeusername') }} />
                                </div>}
                                {this.state.IsNorway && this.state.CustomerType === '20' && <div style={{ fontSize: '14px' }}>
                                    <span dangerouslySetInnerHTML={{ __html: t('selfcare:item.cannotchangecompanyname') }} />
                                </div>}    
                            </GridItem>
                        </GridContainer>
                    </div>
                    <div>
                    {this.state.DisabledMessage && <div style={{ backgroundColor: 'black', color: 'white', padding: '5px', textAlign: 'center', borderBottom: '1px grey solid' }}>{this.state.DisabledMessage}</div>}
                        <GridContainer justify="center">
                            <MuiThemeProvider theme={theme}>
                                    <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                    {this.state.CanRetrieveAddress && <Button size="sm" onClick={() => { this.setState({ buzy: true }); this.dispatchState({ GetUpdatedAddress: true }); }} disabled={this.state.buzy || this.state.Disabled} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:button.fetchaddressnationalregistry')}</Button>}
                                    <div style={{ paddingTop: '20px', paddingLeft: '10px', fontWeight: '700' }}>{t('selfcare:title.customerinfo')}</div>
                                    <GridContainer>
                                        {this.state.CustomerType === '10' &&
                                            <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                                <TextField fullWidth
                                                    disabled
                                                label={t('selfcare:label.firstname')}
                                                    value={this.state.Firstname}
                                                    id="Firstname"
                                                    className={classes.textField}
                                                    helperText=""
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </GridItem>}
                                        {this.state.CustomerType === '10' &&
                                            <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                                <TextField fullWidth
                                                    disabled
                                                label={t('selfcare:label.lastname')}
                                                    value={this.state.Lastname}
                                                    id="Lastname"
                                                    className={classes.textField}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </GridItem>}
                                        {this.state.CustomerType === '10' &&
                                            <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                                <TextField fullWidth
                                                    disabled
                                                label={t('selfcare:label.birthdate')}
                                                    value={this.state.Birthdate}
                                                    id="Birthdata"
                                                    className={classes.textField}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </GridItem>}
                                        {this.state.CustomerType === '20' &&
                                            <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                                <TextField fullWidth
                                                    disabled
                                                label={t('selfcare:label.companyname')}
                                                    value={this.state.CompanyName}
                                                    id="CompanyName"
                                                    className={classes.textField}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </GridItem>}
                                        {this.state.CustomerType === '20' &&
                                            <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                                <TextField fullWidth
                                                    disabled
                                                label={t('selfcare:label.organizationnumber')}
                                                    value={this.state.OrgNo}
                                                    id="OrgNo"
                                                    className={classes.textField}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </GridItem>}
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'ContactPhone'}
                                                disabled={this.state.buzy || this.state.Disabled}
                                                label={t('selfcare:label.contactnumber')}
                                                value={this.state.ContactPhone}
                                                onChange={this.handleChange('ContactPhone')}
                                                id="ContactPhone"
                                                type='tel'
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{ maxLength: 8 }}
                                                className={classes.textField}
                                                helperText={this.state.ErrorField === 'ContactPhone' && this.state.ErrorText}
                                                inputRef={(el) => { this.ContactPhone = el; }} 
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'EmailAddress'}
                                                disabled={this.state.buzy || this.state.Disabled}
                                                label={t('selfcare:label.email')}
                                                value={this.state.EmailAddress}
                                                onChange={this.handleChange('EmailAddress')}
                                                id="EmailAddress"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 50 }}
                                                type='email'
                                                helperText={this.state.ErrorField === 'EmailAddress' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.EmailAddress = el; }} 
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <div style={{ paddingTop: '20px', paddingLeft: '10px', fontWeight: '700' }}>{t('selfcare:label.address')}</div>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'CoAddress'}
                                                disabled={this.state.buzy || this.state.Disabled}
                                                label={t('selfcare:label.coname')}
                                                value={this.state.CoAddress}
                                                onChange={this.handleChange('CoAddress')}
                                                id="CoAddress"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30 }}
                                                helperText={this.state.ErrorField === 'CoAddress' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.CoAddress = el; }} 
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'AddressLine'}
                                                disabled={this.state.buzy || this.state.Disabled}
                                                label={t('selfcare:label.address')}
                                                value={this.state.AddressLine}
                                                onChange={this.handleChange('AddressLine')}
                                                id="AddressLine"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30 }}
                                                helperText={this.state.ErrorField === 'AddressLine' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.AddressLine = el; }} 
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'PostalCode'}
                                                disabled={this.state.buzy || this.state.Disabled}
                                                label={t('selfcare:label.postalcode')}
                                                value={this.state.PostalCode}
                                                onChange={this.handleChange('PostalCode')}
                                                id="PostalCode"
                                                className={classes.textField}
                                                type='tel'
                                                inputProps={{ maxLength: { postcodelen } }}
                                                helperText={this.state.ErrorField === 'PostalCode' && this.state.ErrorText}
                                                InputLabelProps={{ shrink: true }}
                                                inputRef={(el) => { this.PostalCode = el; }} 
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={6} style={{ padding: '10px' }}>
                                            <TextField fullWidth
                                                disabled
                                                label={t('selfcare:label.postalcity')}
                                                value={this.state.City}
                                                id="City"
                                                InputLabelProps={{ shrink: true }}
                                                className={classes.textField}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer direction="row">
                                        <GridItem>
                                            <div style={{ paddingTop: '20px' }}>
                                                <Button size="sm" onClick={() => { this.handleSave(); }} disabled={this.state.buzy || this.state.Disabled} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:button.update')}</Button>
                                                <ButtonX id='cancel' size="small" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                            </div>
                                        </GridItem>
                                    </GridContainer>
                                    {this.state.buzy && <GridItem>
                                        <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                    </GridItem>}
                                </GridItem>
                            </MuiThemeProvider>
                        </GridContainer>
                        </div>
            </div>
        );
    }
}
ChangeAddress.propTypes = {
};

export default compose(
    withStyles(styles),
    withTranslation(),
)(withAITracking(reactPlugin, ChangeAddress));



